import { useSelector } from "react-redux";
import { selectIsAdmin } from "./adminSlice";
import { Route, Routes } from "react-router-dom";
import Prices from "./prices/Prices.jsx";
import OverPrices from "./overPrices/OverPrices.jsx";
import Users from "./users/Users.jsx";

const Admin = () => {
    const isAdmin = useSelector(selectIsAdmin);

    return (
        <>
            {isAdmin === "loading" && <div>Loading...</div>}
            {!isAdmin && (
                <div className="text-red-400 text-2xl">Forbidden!!!</div>
            )}
            {isAdmin !== "loading" && isAdmin && (
                <div>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/prices" element={<Prices />} />
                        <Route path="/over-prices" element={<OverPrices />} />
                        <Route path="/users" element={<Users />} />
                    </Routes>
                </div>
            )}
        </>
    );
};

const Home = () => {
    return (
        <div>
            This is admin page
            <br />
            <br />
            You can use navbar to change prices or logout in profile
        </div>
    );
};

export default Admin;
